"use client";

import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { passkeyClient } from "@better-auth/passkey/client";
import {
	organizationClient,
	type SigmaSignInOptions,
	sigmaClient,
} from "@sigma-auth/better-auth-plugin/client";
import {
	customSessionClient,
	deviceAuthorizationClient,
	emailOTPClient,
	twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from "@/lib/auth";

const client = createAuthClient({
	baseURL: typeof window === "undefined" ? "" : window.location.origin,
	plugins: [
		sigmaClient(),
		// Organization client for BAP identity management
		// BAP IDs are mapped as organizations with single-owner membership
		organizationClient(),
		emailOTPClient(),
		oauthProviderClient(),
		passkeyClient(),
		twoFactorClient({
			onTwoFactorRedirect() {
				window.location.href = "/2fa";
			},
		}),
		// Device Authorization Grant (RFC 8628) for desktop/CLI apps
		deviceAuthorizationClient(),
		// Enables typed access to custom session fields (like onboarding_completed)
		customSessionClient<typeof auth>(),
	],
	fetchOptions: {
		credentials: "include",
	},
});

// Extend client type to include sigma plugin actions
export const authClient = client as typeof client & {
	signIn: typeof client.signIn & {
		sigma: (
			options?: SigmaSignInOptions
		) => ReturnType<typeof client.signIn.email>;
	};
};

// Export destructured methods for convenience
export const { signIn, signOut, signUp, useSession } = authClient;
